import toKebab from './toKebab'

const toSnake = str => toKebab(str).replace(/-/g, '_')
export default toSnake
